<template>
  <footer
    class="w-full bg-realBlack text-white pt-[12vh] pb-6 relative md:border-none border-t border-t-white border-opacity-25"
  >
    <div class="mx-auto w-[90%] max-w-xl">
      <div class="w-full">
        <div
          class="flex flex-col items-start w-full gap-8 md:flex-row md:gap-0"
        >
          <div class="w-full md:w-7/12">
            <div
              class="flex flex-col items-start justify-between w-full gap-8 md:flex-row md:gap-0"
            >
              <div class="w-3/5 md:w-auto">
                <img
                  src="@/assets/images/whiteLogo.png"
                  class="md:w-auto w-[130px]"
                  alt="Logo"
                />
              </div>
              <div class="w-auto md:w-8/12">
                <h6
                  class="mb-6 text-lg font-bold text-white capitalize font-inter"
                >
                  Vehicle Catalogue
                </h6>
                <ul class="p-0 list-none">
                  <!-- <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'panther' }">
                      Panther
                    </router-link>
                  </li> -->
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'imperial' }">
                      Imperial
                    </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'savannah' }">
                      Savannah
                    </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'sill' }"> Sill </router-link>
                  </li>

                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'javan' }"> Javan </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <a
                      href="/assets/doc/Qoray EV Catalogue_0807.pdf"
                      download
                    >
                      Download Brochure
                    </a>
                  </li>
                  <!-- <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }"> Panther </router-link>
                  </li> 
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }"> Savannah </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }"> Bear </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }"> Seal </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }"> Atlas </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }"> Pika </router-link>
                  </li>

                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }"> Teak </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }"> Beluga </router-link>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
          <div class="w-full md:w-5/12">
            <div
              class="flex flex-col items-start w-full gap-8 md:flex-row md:gap-0"
            >
              <div class="w-full md:w-3/5">
                <h6
                  class="mb-6 text-lg font-bold text-white capitalize font-inter"
                >
                  Services
                </h6>
                <ul class="p-0 list-none">
                  <li class="mb-4 text-base font-medium font-inter">
                    <a href="/#pmd">Financing </a>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <a href="/#pmd">Energy networks </a>
                  </li>
                  <!-- <li class="mb-4 text-base font-medium font-inter">
                    <span>Switch </span>
                  </li> -->
                  <li class="mb-4 text-base font-medium font-inter">
                    <a href="/#pmd">Manufacturing, Assembly and Sales </a>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <a href="/#pmd">Mobility as a Service </a>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <span>Tour with Qoray </span>
                  </li>
                </ul>
              </div>
              <div>
                <h6
                  class="mb-6 text-lg font-bold text-white capitalize font-inter"
                >
                  More
                </h6>
                <ul class="p-0 list-none">
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'faq' }"> FAQs </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <!-- <router-link :to="{ name: 'home' }"
                      > -->
                    <router-link :to="{ name: 'contact' }">
                      Contact Us
                    </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <!-- <router-link :to="{ name: 'home' }"
                      > -->
                    <a href="tel:+2348133059384" class="cursor-pointer">
                      +234 813 305 9384
                    </a>
                    <!-- </router-link> -->
                  </li>
                  <!-- <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }">Media </router-link>
                  </li>
                  <li class="mb-4 text-base font-medium font-inter">
                    <router-link :to="{ name: 'home' }">News </router-link>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-center w-full gap-6 mt-12 mb-16 text-white">
        <a href="https://www.instagram.com/qoraymobility/" target="_blank">
          <!-- <img src="@/assets/svgs/instagram.svg" alt="" /> -->
          <Instagram />
        </a>
        <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/threads.svg" alt="" />
        </a> -->
        <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/linkedin.svg" alt="" />
        </a> -->
        <a href="https://x.com/qoraymobility" target="_blank">
          <!-- <img src="@/assets/svgs/twitter.svg" alt="" /> -->
          <Twitter />
        </a>
        <a href="https://www.youtube.com/@QorayMobility" target="_blank">
          <!-- <img src="@/assets/svgs/youtube.svg" alt="" /> -->
          <Youtube />
        </a>
        <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/facebook.svg" alt="" />
        </a> -->
      </div>
      <div
        class="flex flex-wrap items-center justify-center w-full md:flex-nowrap md:justify-start gap-y-4"
      >
        <p class="font-inter pr-6 border-r border-[#BEBBBB]">
          &copy;{{ year }} Qoray. All rights reserved
        </p>
        <p class="font-inter px-6 border-r text-center border-[#BEBBBB]">
          <router-link :to="{ name: 'terms' }"> Terms of Use</router-link>
        </p>
        <p class="font-inter px-6 text-center border-[#BEBBBB]">
          <router-link :to="{ name: 'privacy' }"> Privacy Policy</router-link>
        </p>
        <!-- <p class="font-inter px-6 border-l text-center border-[#BEBBBB]">
          <router-link :to="{ name: 'home' }"> Cookie Settings</router-link>
        </p> -->
      </div>
    </div>
  </footer>
</template>

<script>
import Instagram from "@/components/Instagram.vue";
import Twitter from "@/components/Twitter.vue";
import Youtube from "@/components/Youtube.vue";
export default {
  components: {
    Instagram,
    Twitter,
    Youtube,
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
  methods: {
    contactUs() {
      this.$store.dispatch("contactUs");
    },
  },
};
</script>

<style></style>
